import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Typography, Button, Avatar } from '@mui/material';
const VisitorMeetingConfirm = ({ clearForm }) => {
   return (
      <>
         <Avatar sx={{ m: 1, bgcolor: 'green' }}>
            <CheckCircleIcon />
         </Avatar>
         <Typography variant="h5" component="h2">
            All Done!
         </Typography>
         <Typography variant="body1" component="p" align="center">
            Thank you for using our Visitor Registration Form.
         </Typography>
         <Button
            onClick={clearForm}
            fullWidth
            variant="contained"
            color="primary"
            sx={{ margin: [3, 0, 2] }}
         >
            Done
         </Button>
      </>
   );
};
export default VisitorMeetingConfirm;
